/* eslint-disable no-unused-vars */
import { RefObject, useRef } from 'react'
import { useGSAP } from '@gsap/react'
import gsap from 'gsap'

import { MediaQuery } from '@/constants'

import { Animation } from '@/types'

type RevealProps = {
  children: (ref: RefObject<HTMLDivElement>) => React.ReactNode
  animation: (props: Animation<HTMLElement>) => (() => void) | void // gsap.core.Timeline
  nodeRef?: RefObject<HTMLElement>
  revertOnUpdate?: boolean
}

const Reveal = ({
  nodeRef,
  children,
  animation,
  revertOnUpdate = true
}: RevealProps) => {
  const root = useRef<HTMLDivElement>(null!)

  useGSAP(
    (context) => {
      const matchMedia = gsap.matchMedia(root.current)

      matchMedia.add(
        {
          isSmall: MediaQuery.SMALL,
          isLarge: MediaQuery.LARGE
        },
        ({ conditions }) => {
          const revert = animation({
            node: root.current,
            reverse: true,
            conditions,
            nodeRef,
            context
          })

          return () => {
            if (revert) {
              revert()
            }
          }
        }
      )

      return () => {
        matchMedia.revert()
      }
    },
    {
      dependencies: [],
      scope: nodeRef || root,
      revertOnUpdate
    }
  )

  return children(root)
}

export default Reveal
